export const countUniqueArticleViewsOnClientId = {
  analysisType: 'count_unique',
  eventCollection: 'kb.article.view',
  key: 'countUniqueArticleViewsOnClientId',
  targetProperty: 'actor.client.id',
}
